export const KZAS_URL = 'https://fin.zapimoveis.com.br/financiamento/simulacao?utm_source=zapimoveis.com.br&utm_medium=referral&utm_campaign=aquisicao'
export const KZAS_IFRAME_URL = 'https://simulador.financiamento.ai/calculadora?value='
export const APPROVAFACIL_URL = 'https://www.approvafacil.com.br/zap/analise-credito/identificacao/1'

export const PARTNERS = {
  KZAS: 'kzas',
  APPROVAFACIL: 'approvaFacil',
}
